import { memo, useMemo } from 'react'
import { Chip as MuiChip, ChipProps as MuiChipProps, SxProps } from '@mui/material'
import clsx from 'clsx'
import Text from '../Text'
import { chipStyles as styles } from './Chip.style'
import { chipClasses } from './Chip.data'
import { ChipProps } from './Chip.types'

function Chip(props: ChipProps) {
  const {
    label,
    sx,
    color = 'success',
    iconColor,
    className,
    textProps = {},
    ...otherProps
  } = props
  const { sx: textSx, ...otherTextProps } = textProps

  const iconColorSx = useMemo(() => {
    return iconColor
      ? {
          [`&.${chipClasses.base} .${chipClasses.icon}`]: {
            color: iconColor,
          },
        }
      : false
  }, [iconColor])

  return (
    <MuiChip
      className={clsx(chipClasses.base, className)}
      sx={[styles.chip, iconColorSx, sx] as SxProps}
      label={
        <Text sx={[styles.text, textSx] as SxProps} {...otherTextProps}>
          {label}
        </Text>
      }
      variant="outlined"
      color={color as MuiChipProps['color']}
      {...otherProps}
    />
  )
}

export default memo(Chip)
